import { useState } from 'react';

import { Button, Menu, MenuItem } from '@material-ui/core';

import { RiSpeedUpLine } from '@remixicon/react';

const SPEED_OPTIONS = [0.5, 0.75, 1, 2, 4, 8];

type SpeedMenuProps = {
  speed: number;
  onSpeedChange: (speed: number) => void;
};

export const SpeedMenu = ({ speed, onSpeedChange }: SpeedMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <>
      <Button
        size="small"
        variant="text"
        color="inherit"
        aria-label="Playback speed"
        startIcon={<RiSpeedUpLine size={16} />}
        onClick={e => setAnchorEl(e.currentTarget)}
      >
        {speed}x
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        getContentAnchorEl={null}
        PaperProps={{
          style: {
            minWidth: 80,
            marginTop: -8,
            color: 'var(--text-base)',
          },
        }}
      >
        {SPEED_OPTIONS.map(s => (
          <MenuItem
            key={s}
            selected={s === speed}
            data-track-id="menuitem.playback-speed"
            data-track-action="update"
            data-track-data-playback-speed={s}
            onClick={() => {
              onSpeedChange(s);
              setAnchorEl(null);
            }}
          >
            {s}x
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
